import { createTheme } from "@mui/material/styles";
import { colours } from "./colours";
import { layers } from "./layers";
import { makeSpacing, type RowanTheme } from "./customTheme";
import { typography } from "./typography";

declare module "@mui/material/styles" {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface Theme extends RowanTheme {}
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface ThemeOptions extends RowanTheme {}
}

export const theme = createTheme({
  colours: colours,
  palette: {
    primary: {
      main: colours.primary.mid.dark20,
    },
    secondary: {
      main: colours.accent.mid.light20,
    },
    error: {
      main: colours.error.mid.mid,
    },
    success: {
      main: colours.success.mid.mid,
    },
    text: {
      primary: colours.uIGrey.mid.mid,
      secondary: colours.uIGrey.mid.light_10,
    },
  },
  typography: {
    fontFamily: `"Manrope", sans-serif;`,
  },
  customTypography: { ...typography },
  spacing: makeSpacing,
  breakpoints: {
    values: {
      xs: 0,
      sm: 480,
      md: 768,
      lg: 1024,
      xl: 1440,
    },
  },
  layout: {
    contentMaxWidth: "150ch",
    gutter: "8vw",
  },
  layers: layers,
});
